import "core-js/stable";
import React from "react";
import ReactDOM from "react-dom";
import App from "./components/App";
import "./Declarations.d.ts";
import { analyticsToolStartEvent } from './utils/Analytics';


ReactDOM.render(<App />, document.getElementById("app"));
analyticsToolStartEvent();